import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpService } from '../../../../shared/ajs-bridges/http.service';
import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';
import { ImportService } from '../../../../shared/basic-data-management/import-service.class';

import { ClasseOuvrage } from '../entities/classe-ouvrage.entity';
import { OuvrageTLR } from '../entities/ouvrage-tlr.entity';

@Injectable({ providedIn: 'root' })
export class OuvrageService extends ImportService {
	private path: string;

	private ouvrageTLRSubService!: BasicDataSubService<OuvrageTLR>;
	private classeOuvrageSubService: BasicDataSubService<ClasseOuvrage>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(HttpService) private httpService: HttpService, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: OuvrageService //
	) {
		super(
			httpClient,
			cachedDataSurveyService,
			"ouvrages",
			"Ouvrage",
		);
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let ouvragesChanged$ = this.cachedDataSurveyService.getChangeNotification("Ouvrage");
		this.ouvrageTLRSubService = new BasicDataSubService<OuvrageTLR>(httpClient, this.path + 'ouvrages?format=TLR', ouvragesChanged$);
		let classesOuvragesChanged$ = this.cachedDataSurveyService.getChangeNotification("ClasseOuvrage");
		this.classeOuvrageSubService = new BasicDataSubService<ClasseOuvrage>(httpClient, this.path + 'ouvrages/classes', classesOuvragesChanged$);
	}

	// Methode recuperant les ouvrages selon le profil et l'antenne de l'utilisateur.
	public getAllOuvragesSelonProfilAndAntenne(profil: string, antenneId: number): Promise<any> {
		let ouvragesPath = this.path + 'ouvrages/optimised';
		if (profil !== 'ADMIN' && profil !== 'REFERENT') {
			ouvragesPath += '/antenne/' + antenneId;
		}
		let result = this.httpService.get(ouvragesPath);
		return result;
	}

	// Methode recuperant tous les ouvrages.
	public getAllOuvrages(): Promise<any> {
		let ouvragesPath = this.path + 'ouvrages/';
		let result = this.httpService.get(ouvragesPath);
		return result;
	}

	// Methode permettant de recuperer un ouvrage a partir de son identifiant.
	public getOuvrageById(id: number): Promise<any> {
		let ouvragePath = this.path + 'ouvrages/' + id;
		let result = this.httpService.get(ouvragePath);
		return result;
	}

	// Methode permettant d'ajouter un ouvrage.
	public create(data: any): Promise<any> {
		let url = this.path + 'ouvrages/';
		let result = this.httpService.post(url, data);
		return result;
	}

	// Methode permettant de modifier un ouvrage.
	public update(id: number, data: any): Promise<any> {
		let url = this.path + 'ouvrages/' + id;
		let result = this.httpService.put(url, data);
		return result;
	}

	// Methode permettant de supprimer un Ouvrage.
	public deleteOuvrage(id: number): Promise<any> {
		let ouvragePath = this.path + 'ouvrages/' + id;
		let result = this.httpService.delete(ouvragePath);
		return result;
	}

	// Methode permettant de recuperer les ouvrages d'un parc
	public getOuvragesByIdParc(idParc: number): Promise<any> {
		let ouvragesPath = this.path + 'ouvrages/parc/' + idParc;
		let result = this.httpService.get(ouvragesPath);
		return result;
	}

	// Methode permettant de recuperer les ouvrages fils d'un ouvrage pere
	public getOuvragesByParent(parentId: number): Promise<any> {
		let ouvragesPath = this.path + 'ouvrages/parents/' + parentId;
		let result = this.httpService.get(ouvragesPath);
		return result;
	}

	// Methode recuperant toutes les classes d'ouvrages.
	public getClasses(): Promise<any> {
		let classesPath = this.path + 'ouvrages/classes';
		let result = this.httpService.get(classesPath);
		return result;
	}

	// Methode recuperant tous les modèles d'ouvrages.
	public getModelesOuvrages(): Promise<any> {
		let modelesPath = this.path + 'ouvrages/modeles';
		let result = this.httpService.get(modelesPath);
		return result;
	}

	// Methode récupérant les classes d'ouvrages présentes sur un parc.
	public getClassesDuParc(idParc: number): Promise<any> {
		let classesPath = this.path + 'ouvrages/parc/' + idParc + '/classes';
		let result = this.httpService.get(classesPath);
		return result;
	}

	public exportOuvrages(): Promise<any> {
		let url = this.path + 'ouvrages/export';
		return this.httpService.getAsArrayBuffer(url);
	}

	// Methode permettant de savoir si un ouvrage a des acces en cours.
	public hasAccesEnCours(id: number): Promise<any> {
		return this.httpService.get(this.path + 'ouvrages/hasAccesEnCours/' + id);
	}

	// Methode permettant de recuperer les ouvrages sur lesquels l'utilisateur est CAC.
	public getOuvragesOnWhichUserIsCac(userId: number): Promise<any> {
		let ouvragePath = this.path + 'ouvrages/onWhichUserIsCac/' + userId;
		console.log("Appel au service Ouvrage");
		console.log(ouvragePath);
		let result = this.httpService.get(ouvragePath);
		return result;
	}

	///////////////////////////////////////////
	// Nouvelles fonctions en pur Angular 12 //
	///////////////////////////////////////////

	// Methode permettant le chargement de tous les ouvrages
	public getOuvrageTLRList = () => this.ouvrageTLRSubService.getList();

	// Methodes permettant le chargement de tous les ouvrages indexes de differentes manieres
	public getOuvrageTLRMapById = () => this.ouvrageTLRSubService.getMapById();
	public getOuvrageTLRById = (id: number) => this.ouvrageTLRSubService.getKnownById(id, "OuvrageTLR");
	public getOuvrageTLRMapByParc = () => this.ouvrageTLRSubService.getMapByForeignKey("byParc", (ouvrage: OuvrageTLR) => ouvrage.parcId);
	public getOuvrageTLRByParc = (id: number) => this.ouvrageTLRSubService.getByForeignKey("byParc", (ouvrage: OuvrageTLR) => ouvrage.parcId, id);

	// Methode permettant de recuperer les ouvrages lies a un acces
	public getOuvrageTLRByAcces(idAcces: number): Observable<OuvrageTLR[]> {
		let url = this.path + 'acces/' + idAcces + '/ouvrages';
		return this.httpClient //
			.get<OuvrageTLR[]>(url) //
			;
	}

	// Methode permettant de recuperer les ouvrages "concernes" par un acces
	public getOuvrageConcerneTLRByAcces(idAcces: number): Observable<OuvrageTLR[]> {
		let url = this.path + 'acces/' + idAcces + '/ouvrages-concernes';
		return this.httpClient //
			.get<OuvrageTLR[]>(url) //
			;
	}

	// Methode permettant de recuperer les ouvrages assignes a un utilisateur CAC
	public getOuvragesTLRByResponsabilite(userId: number, typeResponsabilite: string): Observable<OuvrageTLR[]> {
		console.log('recherche liste des ouvrages pour lesquels userId: ', userId, ' est ', typeResponsabilite);
		let url = this.path + 'users/' + typeResponsabilite.toLowerCase() + '/' + userId + '/ouvrages-assignes';
		return this.httpClient.get<OuvrageTLR[]>(url);
	}

	// Methode permettant de recuperer les classes d'ouvrage
	public getClasseOuvrageList = () => this.classeOuvrageSubService.getList();
}